import { useQuery } from "@tanstack/react-query";
import React from "react";
import { useSearchParams } from "react-router-dom";
import { getEntities } from "src/api/settings";
import CustomDataTable from "src/components/CustomDataTable";
import CustomDropdown from "src/components/CustomDropdown";
import CustomModal from "src/components/CustomModal";
import CreateWarehouse from "src/components/modals/CreateWarehouse";
import PermissionWrapper from "src/components/PermissionWrapper";
import { Button } from "src/components/ui/button";
import useHasPermissions from "src/hooks/useHasPermissions";
import "src/array";
import { EllipsisIcon } from "src/svg";

const columns = (hasEditPermission) => [
	{ name: "S/N", selector: (_, index) => index + 1, width: "90px" },
	{ name: "Name", selector: (row) => row.name, style: { textTransform: "capitalize" }, grow: 1.25 },
	{ name: "Manager", selector: (row) => (row.first_name ? `${row.first_name} ${row.last_name}` : "N/A") },
	{ name: "Type", selector: (row) => row.type, style: { textTransform: "capitalize" }, grow: 0.75 },
	{
		name: "Action",
		cell: (row) => (
			<CustomDropdown
				trigger={
					<Button variant="hover">
						<EllipsisIcon />
					</Button>
				}
				actions={[].appendToArray(
					[
						{
							label: (
								<CustomModal title="Edit Warehouse/Storefront" trigger={<span>Edit</span>}>
									<CreateWarehouse entity={row} />
								</CustomModal>
							),
							asChild: true,
						},
					],
					hasEditPermission
				)}
			/>
		),
		maxWidth: "70px",
	},
];

const WarehouseSettings = () => {
	const hasEditPermission = useHasPermissions("update_entity");
	const [searchParams] = useSearchParams();
	const page = searchParams.get("page");
	const limit = searchParams.get("limit");

	const { data, isLoading } = useQuery({
		queryKey: ["entities", page, limit],
		queryFn: () => getEntities({ page, limit }),
	});

	const entities = data?.data?.data ?? [];
	const totalRow = data?.data?.total;

	return (
		<div className="settings_cont_ins">
			<div className="pageTop tw-flex tw-items-center tw-justify-between">
				<h2>Warehouses/Storefronts</h2>
				<PermissionWrapper permission="add_entity">
					<div className="">
						<CustomModal
							title="Create Warehouse/Storefront"
							trigger={<Button className="!tw-rounded-full !tw-py-2">Create Warehouse/Storefront</Button>}
						>
							<CreateWarehouse />
						</CustomModal>
					</div>
				</PermissionWrapper>
			</div>

			<div className="innerContent">
				<CustomDataTable data={entities} columns={columns(hasEditPermission)} progressPending={isLoading} paginationTotalRows={totalRow} />
			</div>
		</div>
	);
};

export default WarehouseSettings;
